import { createSlice } from "@reduxjs/toolkit";
import {
	editDemandSheet,
	getDemandSheetByID,
	getDemandSheet,
	postDemandSheet,
	getDemandSheetItemsBySuperStockist,
	demandSheetExport,
	getDemandSheetItemsByRoute,
	getSchemeByDistributorIDAndProductId,
	getPriceByDistributorIDAndProductId,
	getDemandSheetProductSchemes,
	getDemandSheetItemsByRouteFulfilled,
	getDemandSheetDraftItemsBySuperStockist,
	postDraftDemandSheet,
} from "./demandsheet.action";
import { Input } from "antd";
import { v4 as uuidv4 } from "uuid";
import { appliedScheme } from "../../../helpers/Helper";

const calculateTotal = (demandsheetsList, key) =>
	demandsheetsList
		.filter((item) => item.key !== "total")
		.reduce((acc, item) => acc + parseFloat(item[key] || 0), 0);

const calculateDistributorTotal = (item) => {
	const total_row_price = parseFloat(
		Object.entries(item)
			.filter(([key]) => key.includes("-price-"))
			.reduce((acc, [key, value]) => acc + parseFloat(value || 0), 0)
	).toFixed(2);


	return parseFloat(total_row_price).toFixed(2);
};

const updateDistributor = (item, payload) => {
	const priceKey = payload.pricekey;
	return {
		...item,
		[payload.key]: payload.value,
		[priceKey]: payload.price, // Ensure priceKey is correctly set
		d_total: calculateDistributorTotal({
			...item,
			[payload.key]: payload.value,
			[priceKey]: payload.price,
		}),
	};
};
const updateTotal = (demandsheetsList, payload) => ({
	...demandsheetsList.find((item) => item.key === "total"),
	[payload.key]:
		calculateTotal(demandsheetsList, payload.key) * payload.base_units,
	d_total: demandsheetsList
		.filter((item) => item.key !== "total")
		.reduce((acc, item) => acc + parseFloat(item.d_total || 0), 0)
		.toFixed(2),
});

const demandsheetSlice = createSlice({
	name: "demandsheet",
	initialState: {
		loading: false,
		error: "",
		status: "",
		list: [],
		selectedData: {
			new_product_type: {},
		},
		distributors: [],
		products: [],
		quantities: [],
		demandSheetQuantities:[],
		demandsheetsList: [],
		draft_data: [],
		DraftReady: false,
		count: 0,
		drawer: false,
		openAddressModal: false,
		openAddAddressModal: false,
		filterParams: {},
		productsList: [],
		free_quantities: [],
		productData: {},
		unitsLoading: false,
		productListparams: {
			start_date: "",
			end_date: "",
			no_of_pages: 0,
			page_size: 10,
			page: 1,
			search: "",
		},
		pageParams: {
			start_date: "",
			end_date: "",
			no_of_pages: 0,
			page_size: 10,
			page: 1,
			search: "",
		},
	},
	reducers: {
		isDrawerVisible: (state, action) => {
			return {
				...state,
				drawer: action.payload,
			};
		},
		
		// changeDemandSheetList: (state, action) => {
		// 	const calculateTotal = (demandsheetsList) => {
		// 		return demandsheetsList
		// 			.filter((item) => item.key !== "total")
		// 			.reduce(
		// 				(acc, item) =>
		// 					acc + parseFloat(item[action.payload.key] || 0),
		// 				0
		// 			);
		// 	};

		// 	const updatedDemandsheetsList = state.demandsheetsList.map(
		// 		(item) => {
		// 			if (item.key === action.payload.distributor_id) {
		// 				// Update the specific distributor's data
		// 				const updatedItem = {
		// 					...item,
		// 					[action.payload.key]: action.payload.value,
		// 				};
		// 				updatedItem.d_total = parseFloat(
		// 					Object.keys(updatedItem)
		// 						.filter((key) => key.includes("-qty-"))
		// 						.reduce(
		// 							(acc, key) =>
		// 								acc +
		// 								parseFloat(updatedItem[key] || 0) *
		// 									updatedItem.total_row_price,
		// 							0
		// 						)
		// 				).toFixed(2);
		// 				return updatedItem;
		// 			}
		// 			return item;
		// 		}
		// 	);

		// 	const updatedProductTotalDemandSheetsList =
		// 		updatedDemandsheetsList.map((item) => {
		// 			if (item.key == "total") {
		// 				return {
		// 					...item,
		// 					[action.payload.key]:
		// 						calculateTotal(updatedDemandsheetsList) *
		// 						action.payload.base_units,
		// 					d_total: parseFloat(
		// 						updatedDemandsheetsList.reduce((acc, value) => {
		// 							if (value.key != "total") {
		// 								console.log(value);
		// 								return acc + parseFloat(value.d_total);
		// 							}
		// 							return acc;
		// 						}, 0)
		// 					).toFixed(2),
		// 				};
		// 			}
		// 			return item;
		// 		});

		// 	return {
		// 		...state,
		// 		demandsheetsList: updatedProductTotalDemandSheetsList,
		// 	};
		// },

		changeDemandSheetList: (state, action) => {
			const updatedDemandsheetsList = state.demandsheetsList.map((item) =>
				item.key === action.payload.distributor_id
					? updateDistributor(item, action.payload)
					: item
			);

			const updatedProductTotalDemandSheetsList =
				updatedDemandsheetsList.map((item) =>
					item.key === "total"
						? updateTotal(updatedDemandsheetsList, action.payload)
						: item
				);

			return {
				...state,
				demandsheetsList: updatedProductTotalDemandSheetsList,
			};
		},
		changeDemandSheetFreeQtyList: (state, action) => {
			const updatedDemandsheetsList = state.demandsheetsList.map((item) =>
				item.key === action.payload.distributor_id
					? {
							...item,
							[action.payload.key]: action.payload.free_quantity,
					  }
					: item
			);

			return {
				...state,
				demandsheetsList: updatedDemandsheetsList,
			};
		},
		setProducts: (state, action) => {
			return {
				...state,
				products: action.payload,
			};
		},
		setFreeQuantities: (state, action) => {
			return {
				...state,
				free_quantities: action.payload,
			};
		},
		changeDemandSheetForAnotherFreeProduct: (state, action) => {
			const { freeObj, newProducts } = action.payload;

			console.log(newProducts);
			return {
				...state,
				products: newProducts,
				demandsheetsList: freeObj
					? state.demandsheetsList.map((ds) => {
							if (ds.key == freeObj.key) {
								return {
									...ds,
									...freeObj,
								};
							}
							return ds;
					  })
					: state.demandsheetsList,
			};
		},
		removeFreeItem: (state, action) => {
			const { product_id, distributor_id } = action.payload;

			// Update the demandsheetsList
			const tempdemandsheetsList = state.demandsheetsList.map((ds) => {
				if (ds.key === distributor_id) {
					// Find the key that contains the `-free_item-` for the given product_id
					const freeItemKey = Object.keys(ds).find(
						(key) =>
							ds[key] === product_id &&
							key.includes("-free_item-")
					);

					if (freeItemKey) {
						// Extract the key prefix before `-free_item-`
						const keyPrefix = freeItemKey.split("-free_item-")[0];

						// Filter out all keys that start with the extracted keyPrefix
						const newDs = Object.keys(ds)
							.filter((key) => !key.startsWith(keyPrefix)) // Keep all keys that do not start with the keyPrefix
							.reduce((acc, key) => {
								acc[key] = ds[key]; // Build the new distributor object
								return acc;
							}, {});

						return newDs; // Return the updated distributor object
					}
				}

				return ds; // If distributor_id doesn't match, return as is
			});

			return {
				...state,
				demandsheetsList: tempdemandsheetsList, // Set the updated list to the state
			};
		},

		changeParams: (state, action) => {
			return {
				...state,
				pageParams: action.payload,
			};
		},
		changeFilterParams: (state, action) => {
			return {
				...state,
				filterParams: action.payload,
			};
		},
		FilterInputChangeValue: (state, action) => {
			return {
				...state,
				filterParams: {
					...state.filterParams,
					[action.payload.key]: action.payload.value,
				},
			};
		},

		setSelectedData: (state, action) => {
			return {
				...state,
				selectedData: action.payload,
			};
		},
		inputChangeValue: (state, action) => {
			return {
				...state,
				selectedData: {
					...state.selectedData,
					...action.payload,
				},
			};
		},
		clearData: (state, action) => {
			return {
				...state,
				loading: false,
				error: "",
				status: "",
				list: [],
				selectedData: {},
				count: 0,
				openAddressModal: false,
				openAddAddressModal: false,
				productsList: [],
				productListparams: {
					start_date: "",
					end_date: "",
					no_of_pages: 0,
					page_size: 10,
					page: 1,
					search: "",
				},
			};
		},
	},
	extraReducers: (builder) => {
		builder
			//get Data
			.addCase(getDemandSheet.pending, (state, action) => {
				state.status = "getDemandSheet loading";
				state.loading = true;
			})
			.addCase(getDemandSheet.fulfilled, (state, action) => {
				state.status = "getDemandSheet succeeded";
				state.loading = false;
				var noofpages = Math.ceil(
					action.payload.count / state.pageParams.page_size
				);
				state.count = action.payload.count;
				state.list = action.payload.results;
				state.pageParams = {
					...state.pageParams,
					no_of_pages: noofpages,
				};
			})
			.addCase(getDemandSheet.rejected, (state, action) => {
				state.status = "getDemandSheet failed";
				state.loading = false;
				state.error = action.error.message;
			})
			// .addCase(
			// 	DemandSheetItemsBySuperStockistFulfilled,
			// 	(state, action) => {
			// 		let payload = action.payload || {};
			// 		state.DraftReady = true;
			// 		state.draft_data = payload?.results; // TODO: need to remove the results
			// 	}
			// )
			//get Data by superstockist id
			.addCase(
				getDemandSheetItemsBySuperStockist.pending,
				(state, action) => {
					state.status = "getDemandSheetItemsBySuperStockist loading";
					state.loading = true;
				}
			)
			.addCase(
				getDemandSheetItemsBySuperStockist.fulfilled,
				(state, action) => {
					state.status =
						"getDemandSheetItemsBySuperStockist succeeded";
					state.loading = false;

					// Extract payload safely
					const {
						distributors = [],
						products = [],
						quantities = [],
					} = action.payload || {};

					// Add UUID to each product
					const processedProducts = products.map((product) => ({
						...product,
						uuid: uuidv4(),
					}));

					// Create a map for fast product lookup
					const productMap = new Map(
						processedProducts.map((product) => [
							product.id,
							product,
						])
					);

					// Prepare an object to aggregate quantities per distributor and product
					const quantityAggregation = {};

					quantities.forEach((quantity) => {
						const {
							distributor_id,
							product_id,
							quantity: qty,
							unit_name,
							unit_id,
							distributor_indent_items_ids,
						} = quantity;

						if (!quantityAggregation[distributor_id]) {
							quantityAggregation[distributor_id] = {};
						}

						if (!quantityAggregation[distributor_id][product_id]) {
							quantityAggregation[distributor_id][product_id] =
								[];
						}

						quantityAggregation[distributor_id][product_id].push({
							quantity: parseFloat(qty),
							unit_name,
							unit_id,
							distributor_indent_items_ids,
						});
					});

					// Generate row data for each distributor
					const tempData = distributors.map((distributor) => {
						const rowData = {
							key: distributor.id,
							fullname: distributor.fullname,
						};

						const productsForDistributor =
							quantityAggregation[distributor.id] || {};

						Object.keys(productsForDistributor).forEach(
							(product_id) => {
								const product = productMap.get(product_id);
								if (product) {
									const quantitiesForProduct =
										productsForDistributor[product_id];

									quantitiesForProduct.forEach(
										(quantity, index) => {
											rowData[
												`${product.id}-qty-${index}`
											] = quantity.quantity.toFixed(2);
											rowData[
												`${product.id}-size-${index}`
											] = quantity.unit_name;
											rowData[
												`${product.id}-unit_id-${index}`
											] = quantity.unit_id;
											rowData[
												`${product.id}-distributor_indent_items_ids-${index}`
											] =
												quantity.distributor_indent_items_ids;
										}
									);
								}
							}
						);

						return rowData;
					});

					// Update state with processed data
					state.demandsheetsList = tempData;
					state.distributors = distributors;
					state.products = processedProducts;
					state.quantities = quantities;
				}
			)
			.addCase(
				getDemandSheetItemsBySuperStockist.rejected,
				(state, action) => {
					state.status = "getDemandSheetItemsBySuperStockist failed";
					state.loading = false;
					state.error = action.error.message;
				}
			)
			//get Data by route id
			.addCase(getDemandSheetItemsByRoute.pending, (state, action) => {
				state.status = "getDemandSheetItemsByRoute loading";
				state.loading = true;
			})
			.addCase(getDemandSheetItemsByRouteFulfilled, (state, action) => {
				state.status = "getDemandSheetItemsByRoute succeeded";
				state.loading = false;
				const {
					distributors = [],
					products = [],
					quantities = [],
					free_quantities = [],
				} = action.payload || {};

				// let new_products = products.map((product) => {
				// 	return {
				// 		...product,
				// 		units: [
				// 			...new Set([
				// 				...free_quantities
				// 					.filter(
				// 						(quantity) =>
				// 							product.id === quantity.product_id
				// 					)
				// 					.map((quantity) => quantity.free_unit_name),
				// 				...quantities
				// 					.filter(
				// 						(quantity) =>
				// 							product.id === quantity.product_id
				// 					)
				// 					.map((quantity) => quantity.unit_name),
				// 			]),
				// 		],
				// 	};
				// });
				let new_products = products.map((product) => {
					return {
						...product,
						units: action.payload.units.filter((eachUnit) => eachUnit.product === product.id).sort((a, b) => a.sequence -b.sequence).map((each) => each.name)
					};
				});
				let new_quantities = [];

				new_products.forEach((product) => {
					product.units.forEach((unit_name) => {
						distributors.forEach((distributor) => {
							const new_free_quantities = free_quantities
								.filter(
									(quantity) =>
										product.id === quantity.product_id &&
										unit_name === quantity.free_unit_name &&
										quantity.distributor_id ===
											distributor.id
								)
								.map((quantity) => {
									return {
										...quantity,
										applied_by_product_id:
											quantity.applied_by_product_id
												? quantity.applied_by_product_id
												: quantity.product_id,
										applied_by_unit_id:
											quantity.applied_by_unit_id
												? quantity.applied_by_unit_id
												: quantity.unit_id,
									};
								});

							// Reduce function to group items with the same properties and sum the quantities
							const reducedItems = new_free_quantities.reduce(
								(acc, current) => {
									const existingItem = acc.find(
										(item) =>
											item.applied_by_product_id ===
												current.applied_by_product_id &&
											item.applied_by_unit_id ===
												current.applied_by_unit_id &&
											item.distributor_id ===
												current.distributor_id
									);

									if (existingItem) {
										existingItem.free_quantity += parseInt(
											current.free_quantity
										); // Sum the quantities
									} else {
										acc.push({
											...current,
											free_quantity: parseInt(
												current.free_quantity
											),
										}); // Add the item if it doesn't exist in accumulator
									}

									return acc;
								},
								[]
							);

							if (reducedItems.length != 0) {
								const sum_new_free_quantities =
									reducedItems.reduce((acc, value) => {
										const temp_value = value.free_quantity
											? parseInt(value.free_quantity)
											: 0;
										return acc + temp_value;
									}, 0);

								new_quantities.push({
									free_quantity: sum_new_free_quantities,
									product_id: product.id,
									distributor_id: distributor.id,
									free_unit_name: unit_name,
									applied_by: reducedItems,
								});
							}
						});
					});
				});

				state.distributors = distributors;
				state.products = products;
				state.quantities = quantities;
				state.free_quantities = new_quantities;
				state.demandSheetQuantities = quantities;
			})
			.addCase(getDemandSheetItemsByRoute.rejected, (state, action) => {
				state.status = "getDemandSheetItemsByRoute failed";
				state.loading = false;
				state.error = action.error.message;
			})

			.addCase(
				getDemandSheetDraftItemsBySuperStockist.pending,
				(state, action) => {
					state.status = "getDemandSheetDraftItemsBySuperStockist loading";
					state.loading = true;
				}
			)
			
			.addCase(
				getDemandSheetDraftItemsBySuperStockist.fulfilled, // This is for the new API call
				(state, action) => {
					state.status = "getDemandSheetDraftItemsBySuperStockist succeeded";
					state.loading = false;
			
					// Iterate over the current state.quantities and update quantity where product_id matches
					const updatedQuantities = state.quantities.map(item => {
						// Find the corresponding item from the API response by product_id
						const matchingDraftItem = action.payload.find(draftItem => draftItem.product.id === item.product_id && draftItem.distributor.id === item.distributor_id && draftItem.unit.id === item.unit_id
						);
			
						// If a matching item is found, update the quantity
						if (matchingDraftItem) {
							return {
								...item, // Keep all other fields the same
								indent_quantity:item.quantity,
								quantity: matchingDraftItem.quantity // Update only the quantity field
							};
						}
						return {
							...item, // Keep all other fields the same
							indent_quantity:item.quantity,
						};
			
						// If no match, return the item as is
					});
			
					// Update the state with the new quantities having updated quantities
					state.quantities = updatedQuantities;
				}
			)

			.addCase(getDemandSheetDraftItemsBySuperStockist.rejected, (state, action) => {
				state.status = "getDemandSheetDraftItemsBySuperStockist failed";
				state.loading = false;
				state.error = action.error.message;
			})
			
			//post data
			.addCase(postDemandSheet.pending, (state, action) => {
				state.status = "postDemandSheet loading";
				state.loading = true;
			})
			.addCase(postDemandSheet.fulfilled, (state, action) => {
				state.status = "postDemandSheet succeeded";
				state.loading = false;
				state.selectedData = {};
			})
			.addCase(postDemandSheet.rejected, (state, action) => {
				state.status = "postDemandSheet failed";
				state.loading = false;
				state.error = action.error.message;
			})


			.addCase(postDraftDemandSheet.pending, (state, action) => {
				state.status = "postDraftDemandSheet loading";
				state.loading = true;
			})
			.addCase(postDraftDemandSheet.fulfilled, (state, action) => {
				state.status = "postDraftDemandSheet succeeded";
				state.loading = false;
				state.selectedData = {};
			})
			.addCase(postDraftDemandSheet.rejected, (state, action) => {
				state.status = "postDraftDemandSheet failed";
				state.loading = false;
				state.error = action.error.message;
			})



			//edit data
			.addCase(editDemandSheet.pending, (state, action) => {
				state.status = "editDemandSheet loading";
				state.loading = true;
			})
			.addCase(editDemandSheet.fulfilled, (state, action) => {
				state.status = "editDemandSheet succeeded";
				state.loading = false;
				state.selectedData = {};
			})
			.addCase(editDemandSheet.rejected, (state, action) => {
				state.status = "editDemandSheet failed";
				state.loading = false;
				state.error = action.error.message;
			})
			.addCase(demandSheetExport.pending, (state, action) => {
				state.status = "demandSheetExport loading";
				state.loading = true;
			})
			.addCase(demandSheetExport.fulfilled, (state, action) => {
				state.status = "demandSheetExport succeeded";
				state.loading = false;
			})
			.addCase(demandSheetExport.rejected, (state, action) => {
				state.status = "demandSheetExport failed";
				state.loading = false;
				state.error = action.error.message;
			})
			//get bu id data
			.addCase(getDemandSheetByID.pending, (state, action) => {
				state.status = "getDemandSheetByID loading";
				state.loading = true;
			})
			.addCase(getDemandSheetByID.fulfilled, (state, action) => {
				state.status = "getDemandSheetByID succeeded";
				state.loading = false;
				const {
					orders = [],
					products = [],
					quantities = [],
					free_quantities = [],
				} = action.payload || {};

				const distributors = action.payload?.orders?.map((order) => {
					return {
						...order.distributor,
						id: order.id,
					};
				});

				let new_products = products.map((product) => {
					return {
						...product,
						units: [
							...new Set([
								...free_quantities
									.filter(
										(quantity) =>
											product.id === quantity.product_id
									)
									.map((quantity) => quantity.free_unit_name),
								...quantities
									.filter(
										(quantity) =>
											product.id === quantity.product_id
									)
									.map((quantity) => quantity.unit_name),
							]),
						],
					};
				});

				let new_quantities = [];

				new_products.forEach((product) => {
					product.units.forEach((unit_name) => {
						orders.forEach((order) => {
							const new_free_quantities = free_quantities
								.filter(
									(quantity) =>
										product.id === quantity.product_id &&
										unit_name === quantity.free_unit_name &&
										quantity.order_id === order.id
								)
								.map((quantity) => ({
									...quantity,
									applied_by_product_id:
										quantity.applied_by_product_id
											? quantity.applied_by_product_id
											: product.id,
									applied_by_unit_id:
										quantity.applied_by_unit_id
											? quantity.applied_by_unit_id
											: quantity.free_unit_id,
								}));

							if (new_free_quantities.length != 0) {
								const sum_new_free_quantities =
									new_free_quantities.reduce((acc, value) => {
										const temp_value = value.free_quantity
											? parseInt(value.free_quantity)
											: 0;
										return acc + temp_value;
									}, 0);

								new_quantities.push({
									free_quantity: sum_new_free_quantities,
									product_id: product.id,
									distributor_id: order.id,
									free_unit_name: unit_name,
									applied_by: new_free_quantities,
								});
							}
						});
					});
				});

				state.distributors = distributors;
				state.products = new_products;
				state.quantities = quantities.map((e) => ({
					...e,
					distributor_id: e.order_id,
					d_total: orders.find((order) => order.id == e.order_id)
						?.d_total,
					d_net: orders.find((order) => order.id == e.order_id)
						?.d_net,
				}));
				state.free_quantities = new_quantities;
				state.selectedData = action.payload;
			})
			.addCase(getDemandSheetByID.rejected, (state, action) => {
				state.status = "getDemandSheetByID failed";
				state.loading = false;
				state.error = action.error.message;
			})
			.addCase(getDemandSheetProductSchemes.pending, (state, action) => {
				state.status = "getDemandSheetProductSchemes loading";
				state.unitsLoading = true;
			})
			.addCase(
				getDemandSheetProductSchemes.fulfilled,
				(state, action) => {
					state.status = "getDemandSheetProductSchemes succeeded";
					var {response,data} = action.payload;
					const { product_id, distributor_id, unit_id, quantity, unit_units, price,unit_name } = data;
					state.productData = {
						...response.data,
						product: {
							id: response.data?.id,
							name: response.data?.name,
							category: response.data?.category,
							image: response.data?.image,
						},
					};

					state.unitsLoading = false;
					
					if (response.data.scheme) {
						var { obj, freeProductObj } = appliedScheme(
							data,
							response.data.scheme
						);
						const scheme = response.data.scheme;
						var new_scheme_product = {
							...scheme?.free_product,
							product: scheme?.product,
							free_unit: scheme?.free_unit,
							free_quantity: obj.free_quantity,
						};

						freeProductObj =
							freeProductObj && freeProductObj?.freeItem
								? freeProductObj
								: new_scheme_product;

						if (scheme?.scheme_type == 2) {
							const freeObj = {
								product_id: freeProductObj.id,
								distributor_id: distributor_id,
								free_quantity: freeProductObj?.free_quantity,
								free_unit_name: freeProductObj?.free_unit.name,
								applied_by: [
									{
										product_id: freeProductObj?.id,
										distributor_id: distributor_id,
										applied_by_product_id: product_id,
										applied_by_unit_id: unit_id,
										base_unit: freeProductObj?.base_unit.name,
										free_unit_id: freeProductObj?.free_unit.id,
										free_unit_name: freeProductObj?.free_unit.name,
										free_unit_units: freeProductObj?.free_unit.units,
										free_quantity: freeProductObj?.free_quantity,
									},
								],
							};

							
							let newQuanitites = state.free_quantities;
							if (
								!state.products.find((product) => product.id === freeProductObj.id)
							) {
								
								let newProducts = [
									...state.products,
									{
										id: freeProductObj.id,
										image: freeProductObj.image,
										name: freeProductObj.name,
										product_type: freeProductObj.product_type,
									},
								];
								// dispatch(setProducts(newProducts));
								state.products = newProducts
								newQuanitites = [...newQuanitites, freeObj];
								// dispatch(setFreeQuantities(newQuanitites));
								state.free_quantities = newQuanitites
								
							} else {
								const check_free_quantities = state.free_quantities.find(
									(item) =>
										item.distributor_id === distributor_id &&
										item.product_id === freeProductObj.id &&
										item.free_unit_name === freeProductObj.free_unit.name
								);

								let updated_free_quantities = state.free_quantities;

								if (check_free_quantities) {
									updated_free_quantities = state.free_quantities.map((item) => {
										if (
											item.distributor_id === distributor_id &&
											item.product_id === freeProductObj.id &&
											item.free_unit_name === freeProductObj.free_unit.name
										) {
											let check_applied_by = item.applied_by.filter(
												(itm) =>
													itm.distributor_id === distributor_id &&
													itm.applied_by_product_id == product_id &&
													itm.applied_by_unit_id == unit_id
											).length;

											let new_applied_by = item.applied_by.map((itm) => {
												if (
													itm.distributor_id === distributor_id &&
													itm.applied_by_product_id == product_id &&
													itm.applied_by_unit_id == unit_id
												) {
													return {
														...itm,
														free_quantity: freeProductObj.free_quantity,
													};
												}
												return itm;
											});

											new_applied_by = check_applied_by
												? new_applied_by
												: [...item.applied_by, ...freeObj.applied_by];

											return {
												...item,
												applied_by: new_applied_by,
												free_quantity: new_applied_by.reduce((acc, value) => {
													const temp_value = value.free_quantity
														? parseInt(value.free_quantity)
														: 0;
													return acc + temp_value;
												}, 0),
											};
										}

										return item;
									});
								} else {
									updated_free_quantities = [
										...state.free_quantities,
										{
											...freeObj,
										},
									];
								}
								// dispatch(setFreeQuantities(updated_free_quantities));
								state.free_quantities = updated_free_quantities
							}
						} else {
							const updatedDataSource = state.free_quantities.map((item) => {
								if (item.distributor_id === distributor_id) {
									let new_applied_by = item.applied_by.filter((itm) => {
										return !(
											itm.applied_by_product_id == product_id &&
											itm.applied_by_unit_id == unit_id
										);
									});
									return {
										...item,
										applied_by: new_applied_by,
										free_quantity: new_applied_by.reduce((acc, value) => {
											const temp_value = value.free_quantity
												? parseInt(value.free_quantity)
												: 0;
											return acc + temp_value;
										}, 0),
									};
								}

								return item;
							});
							// dispatch(setFreeQuantities(updatedDataSource));
							state.free_quantities = updatedDataSource
							
						}
					} else {
						const updatedDataSource = state.free_quantities.map((item) => {
							if (item.distributor_id === distributor_id) {
								let new_applied_by = item.applied_by.filter((itm) => {
									return !(
										itm.applied_by_product_id == product_id &&
										itm.applied_by_unit_id == unit_id &&
										item.distributor_id === distributor_id
									);
								});
								return {
									...item,
									applied_by: new_applied_by,
									free_quantity: new_applied_by.reduce((acc, value) => {
										const temp_value = value.free_quantity
											? parseInt(value.free_quantity)
											: 0;
										return acc + temp_value;
									}, 0),
								};
							}
							return item;
						});
						// dispatch(setFreeQuantities(updatedDataSource));
						state.free_quantities = updatedDataSource
					}

				}
			)
			.addCase(getDemandSheetProductSchemes.rejected, (state, action) => {
				state.status = "getDemandSheetProductSchemes failed";
				state.unitsLoading = false;
				state.error = action.error.message;
			});
	},
});

// Action creators are generated for each case reducer function
export const {
	isDrawerVisible,
	changeParams,
	clearData,
	setSelectedData,
	inputChangeValue,
	changeFilterParams,
	FilterInputChangeValue,
	changeDemandSheetList,
	changeDemandSheetFreeQtyList,
	changeDemandSheetForAnotherFreeProduct,
	setProducts,
	setFreeQuantities,
	removeFreeItem,
} = demandsheetSlice.actions;

export default demandsheetSlice.reducer;
